import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-dashboard',
  templateUrl: 'login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  lang = localStorage.getItem('lang') == "EN" || 'en' ? "EN" : "TH";

  user_data = { username: "", password: "" }
  isLoading = true;
  bsModalRef: BsModalRef;
  constructor(private modalService: BsModalService, private router: Router, private service: MyserviceService, private route: ActivatedRoute) {
    this.route.queryParams.subscribe(params => {
      //debugger
      var lang_show: any;
      if (params.lang == 'en') {
        this.lang = 'EN'
      } else {
        this.lang = 'TH';
      }
      localStorage.setItem('lang', this.lang);
      if (this.lang == 'TH') {
        lang_show = {
          select_title: "กรุณาเลือกเทศบาล",
          ok: "ตกลง",
          cancel: "ยกเลิก"
        }
      } else {
        lang_show = {
          select_title: "Please Choose Municipality",
          ok: "ok",
          cancel: "cancel"
        }
      }
      if (params['token']) {
        //debugger
        var token = params['token']
        console.log(params['token']);
        // &lang=th&type=1&muni=m0010
        this.service.getNewToken(token).then((result: any) => {
          //console.log(result);
          // debugger
          if (result.auth) {
            sessionStorage.setItem('token', result.token);
            sessionStorage.setItem('user', JSON.stringify(result.user))
            //console.log(result);


            this.service.postData({ username: result.user.username, muni: params['muni'] }, "get-municipality").then((result1: any) => {
              if (result1.data.length > 0) {
                sessionStorage.setItem('municipality', JSON.stringify(result1.data[0]));
                // sessionStorage.setItem('img',result1.img)
                this.router.navigate(['/dashboard'])
              } else {
                const initialState = {
                  data: result1.data,
                  title: 'Modal with component'
                };
                // this.bsModalRef = this.modalService.show(ModalContentComponent, {initialState});
                // this.bsModalRef.content.closeBtnName = 'Close';
                // this.isLoading=false;
                var inputOptions = {};
                result1.data.forEach((item) => {
                  inputOptions[item.municipality_id] = this.lang == 'EN' ? item.en_name : item.th_name
                })
                Swal.fire({
                  title: lang_show.select_title,
                  input: 'select',
                  inputOptions: inputOptions,
                  inputPlaceholder: lang_show.select_title,
                  showCancelButton: true,
                  cancelButtonText: lang_show.cancel,
                  confirmButtonText: lang_show.ok,
                  inputValidator: (value) => {
                    return new Promise((resolve, reject) => {
                      if (value !== '') {
                        resolve(value);
                      } else {
                        resolve(lang_show.select_title);
                      }
                    });
                  }
                }).then((result) => {
                  if (result.value) {
                    var item = result1.data.filter((item) => item.municipality_id == result.value)[0];
                    sessionStorage.setItem('municipality', JSON.stringify(item));
                    this.router.navigate(["/dashboard"]);
                  }
                });
              }



            }, err => {
              Swal.fire("something wrong please try again");
            })



          }
        }, err => {
          //debugger;
          console.log(err);
          window.location.href = this.service.start_host
        })
      } else {
        //debugger;
        token = sessionStorage.getItem('token');
        if (token) {
          this.service.checklogin(token).then((result: any) => {
            console.log(result);
            if (result.auth) {
              sessionStorage.setItem('token', token);
              sessionStorage.setItem('user', JSON.stringify(result.gen_token))
              setTimeout(() => {
                this.router.navigate(["/dashboard"]);
              }, 2000)
            }
          }, err => {
            window.location.href = this.service.start_host
          })
        } else {
          window.location.href = this.service.start_host
        }
      }
    });
  }

}


@Component({
  selector: 'modal-content',
  templateUrl: "modal.html"
})

export class ModalContentComponent implements OnInit {
  title: string;
  closeBtnName: string;
  submitted = false;
  data: any;
  municipality: any = "";
  lang = localStorage.getItem('lang') == "EN" || 'en' ? "EN" : "TH";
  constructor(public bsModalRef: BsModalRef, private router: Router) { }

  ngOnInit() {

  }
  changelang(lang) {
    this.lang = lang;
    localStorage.setItem('lang', lang);
  }
  done() {
    this.submitted = true;
    if (this.municipality != "") {
      var item = this.data.filter((item) => item.municipality_id == this.municipality)[0];
      sessionStorage.setItem('municipality', JSON.stringify(item));
      this.bsModalRef.hide();
      this.router.navigate(['/dashboard'])
    }
  }
}
